import { formatNumber } from "../../../utils";

const UsageStatItem = (props: DataItemInterface) => {
  return (
    <div className="flex w-full flex-row rounded-md border p-6 pr-8">
      <span>{props.icon}</span>
      <div className="ml-3.5">
        <p className="text-md font-serif font-[500]">
          {formatNumber(props.data)}
        </p>
        <p className="text-xs">{props.name}</p>
      </div>
    </div>
  );
};

interface DataItemInterface {
  icon: any;
  name: string;
  data: number;
}

export default UsageStatItem;
